const search=document.querySelector('#ke_search_sword');
const resetLink=document.querySelector('.resetbutt');

if(search && resetLink){
    // give the other scripts some time to fill the content from the url
    requestAnimationFrame(()=>{
        const value=search.value;
        if(!value){
            resetLink.classList.add('hidden');
        }else{
            resetLink.classList.remove('hidden');
        }
    })
}